import type { Attribution } from "@kontaktfix/shared";

/*
 * UTM parameters of the link that brought someone to the app (for example from a campaign on the
 * landing page). Kept in sessionStorage for this tab only, so they survive the Microsoft sign-in
 * round trip. No cookie. Sent once with the creation of the organization.
 */

const KEY = "kf-attribution";
const FIELDS = ["source", "medium", "campaign", "term", "content"] as const;

/** First touch wins: a later link in the same tab does not overwrite it. */
export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
  const found: Attribution = {};
  for (const f of FIELDS) {
    const value = params.get(`utm_${f}`);
    if (value) found[f] = value.slice(0, 200);
  }
  if (!Object.keys(found).length) return;
  try {
    if (!sessionStorage.getItem(KEY)) sessionStorage.setItem(KEY, JSON.stringify(found));
  } catch {
    // Storage blocked: the sign-up is just not attributed.
  }
}

export function storedAttribution(): Attribution | undefined {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Attribution) : undefined;
  } catch {
    return undefined;
  }
}
